import styled from 'styled-components'
import { getAlphaRgb } from 'components/layouts'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: -36px;
`

export const EmptyMessage = styled.div`
  color: ${({ theme }) => theme.colors.grey};
  padding: 32px 0;
`

export const UserList = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 586px;
`

export const UserProfile = styled.div`
  cursor: pointer;
  display: flex;
  padding: 36px 0;
  & + & {
    border-top: solid 1px ${({ theme }) => getAlphaRgb(theme.colors.grey, 0.3)};
  }
`

export const AuthorPic = styled.img`
  height: 66px;
  width: 66px;
  min-height: 66px;
  min-width: 66px;
  object-fit: cover;
  object-position: center;
  border-radius: 50%;
  margin-right: 12px;
  ${({ theme }) => theme.media.phone} {
    margin-bottom: 12px;
  }
`
export const AuthorPlaceholder = styled.div`
  height: 66px;
  width: 66px;
  min-height: 66px;
  min-width: 66px;
  border-radius: 50%;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  text-transform: uppercase;
  ${({ theme }) => theme.media.phone} {
    margin-bottom: 12px;
  }
`

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 4px;
`
export const UserName = styled.div`
  ${({ theme }) => theme.font.bold};
`
export const UserDesc = styled.div`
  color: ${({ theme }) => theme.colors.grey};
`
